import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import TuneIcon from 'components/Common/Icons/Tune';
import Button, { ButtonType } from 'components/UI/Buttons/Button/Button';

import styles from './MoreFiltersButton.module.scss';

type PropsType = ButtonType & { active: boolean };

export default function MoreFiltersButton({
  active,
  className,
  ...rest
}: PropsType): JSX.Element {
  const { t } = useTranslation('listingPage');

  return (
    <Button className={classNames(styles.button, className)} {...rest}>
      <TuneIcon />
      {t(active ? 'FEWER_FILTERS' : 'MORE_FILTERS')}
    </Button>
  );
}
